class ProductBrandCarousel extends HTMLElement {
  constructor() {
    super();
    this.fetchAttempts = 0;
    window.initLazyScript(this, this.init.bind(this), 500);
  }

  async init() {
    if (!this.dataset.url) return;

    try {
      const response = await fetch(this.dataset.url);
      if (!response.ok) throw new Error(response.status);

      const tmpl = document.createElement('template');
      tmpl.innerHTML = await response.text();

      const el = tmpl.content.querySelector('product-brand-carousel');
      if (!el || !el.hasChildNodes()) return;

      this.pruneResults(el);

      if (el.querySelector('.slider__item, li[data-product-handle]')) {
        this.innerHTML = el.innerHTML;
      }
    } catch (error) {
      this.fetchAttempts += 1;

      if (this.fetchAttempts < 3) {
        this.init();
      } else {
        console.log(error); // eslint-disable-line
      }
    }
  }

  // Remove the current product's own card, then trim to the requested limit.
  // The section requests limit + 1 products so a full row remains after removal.
  pruneResults(el) {
    const currentHandle = this.dataset.productHandle;
    const limit = parseInt(this.dataset.limit, 10) || Infinity;
    const items = el.querySelectorAll('li[data-product-handle]');

    let shown = 0;
    items.forEach((item) => {
      if (
        (currentHandle && item.dataset.productHandle === currentHandle)
        || shown >= limit
      ) {
        item.remove();
      } else {
        shown += 1;
      }
    });
  }
}

customElements.define('product-brand-carousel', ProductBrandCarousel);
